import { useEffect, useMemo, useState } from 'react'
import type { CalendarEvent } from '../types'

export interface Countdown {
  next: CalendarEvent | undefined
  days: number
  hours: number
  mins: number
  secs: number
}

/** Picks the next upcoming event and counts down to it, ticking every second. */
export function useCountdown(events: CalendarEvent[]): Countdown {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(t)
  }, [])

  return useMemo(() => {
    const next =
      events.find((e) => new Date(e.date).getTime() > now) ?? events[events.length - 1]
    const diff = next ? Math.max(0, new Date(next.date).getTime() - now) : 0
    return {
      next,
      days: Math.floor(diff / 864e5),
      hours: Math.floor(diff / 36e5) % 24,
      mins: Math.floor(diff / 6e4) % 60,
      secs: Math.floor(diff / 1e3) % 60,
    }
  }, [events, now])
}
